import React, { useState } from 'react';
import { Mail, ArrowRight, CheckCircle } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const WaitlistForm = ({ isModal = false, onClose }) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    if (!email || !email.includes('@')) {
      setError('Please enter a valid email address');
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(`${API}/waitlist`, { email });
      
      if (response.data.success) {
        setSubmitted(true);
      } else {
        setError(response.data.message || 'Something went wrong. Please try again.');
      }
    } catch (err) {
      if (err.response?.data?.detail) {
        setError(err.response.data.detail);
      } else {
        setError('Something went wrong. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className={isModal ? "waitlist-modal-content" : "waitlist-section"}>
        <div className="success-message">
          <CheckCircle className="success-icon" />
          <h3 className="success-title">You're on the list!</h3>
          <p className="success-text">
            Check your inbox for a confirmation email. We'll notify you when early access opens.
          </p>
          {isModal && onClose && (
            <Button onClick={onClose} className="btn-secondary">
              Close
            </Button>
          )}
        </div>
      </div>
    );
  }

  return (
    <section className={isModal ? "waitlist-modal-content" : "waitlist-section"}>
      <div className="waitlist-container">
        <h2 className="waitlist-title">Start with Paper Trading</h2>
        <p className="waitlist-subtitle">
          No real money. No pressure. Join early access.
        </p>

        <form onSubmit={handleSubmit} className="waitlist-form">
          <div className="form-group">
            <Mail className="input-icon" />
            <Input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="waitlist-input"
              disabled={loading}
            />
          </div>
          
          {error && <p className="error-message">{error}</p>}
          
          <Button 
            type="submit" 
            className="btn-primary waitlist-submit"
            disabled={loading}
          >
            {loading ? 'Joining...' : 'Join the Early Access Waitlist'}
            <ArrowRight className="w-5 h-5" />
          </Button>
        </form>

        <p className="waitlist-note">
          We'll send you updates about the platform launch and early access details.
        </p>
      </div>
    </section>
  );
};

export default WaitlistForm;
